import React from 'react'
import ProfileCard from '../components/ui/ProfileCard/ProfileCard'
import Ratio from 'react-bootstrap/Ratio'
import { useOutletContext } from 'react-router-dom'

const ManagementTeam = () => {
  const { sectiondata } = useOutletContext() || {}
  const members = sectiondata?.members

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:pt-4">
        {members?.map((member, index) => {
          return (
            <Ratio aspectRatio="1x1" key={index}>
              <ProfileCard cardDetail={member} />
            </Ratio>
          )
        })}
      </div>
    </>
  )
}

export default ManagementTeam
